import React, { useState } from 'react'
import { VisuallyHidden } from 'core/components'
import { Transl } from 'core/translations'
import { Nav, List, Item, NavLink, Label } from './styled'

const PrimaryNav = ({ isOnSurface, asColumn, navItems, inDrawer }) => {
	const [openSubmenus, setOpenSubmenus] = useState({});
	const id = `primary-navigation${inDrawer ? '-mobile' : ''}`;

	const toggleSubmenu = (index) => {
		setOpenSubmenus(prev => ({
			...prev,
			[index]: !prev[index]
		}));
	};

	const closeAllSubmenus = () => {
		setOpenSubmenus({});
	};

	const renderNavItem = (item, index, level = 0) => {
		const hasChildren = item.children && item.children.length > 0;
		const isOpen = openSubmenus[index];

		return (
			<Item key={index} className={level > 0 ? 'submenu-item' : ''}>
				{hasChildren ? (
					<>
						<NavLink
							to="#"
							onClick={(e) => {
								e.preventDefault();
								toggleSubmenu(index);
							}}
							className={isOpen ? 'active' : ''}
						>
							<Label isOnSurface={isOnSurface}>
								{item.title} {isOpen ? '▲' : '▼'}
							</Label>
						</NavLink>
						{isOpen && (
							<List asColumn={true} className="submenu">
								{item.children.map((child, childIndex) =>
									renderNavItem(child, `${index}-${childIndex}`, level + 1)
								)}
							</List>
						)}
					</>
				) : (
					<NavLink exact={item.url === '/'} to={item.url} onClick={closeAllSubmenus}>
						<Label isOnSurface={isOnSurface}>{item.title}</Label>
					</NavLink>
				)}
			</Item>
		);
	};

	return (
		<Nav aria-labelledby={id}>
			<VisuallyHidden>
				<p id={id}>
					<Transl>Galvenā izvēlne</Transl>
				</p>
			</VisuallyHidden>
			<List asColumn={asColumn}>
				{navItems && navItems.map((item, index) => renderNavItem(item, index))}
			</List>
		</Nav>
	);
};

export default PrimaryNav